import React from 'react';

import {Helmet} from 'react-helmet';

interface Props {
  children: string;
}

/** This aims to mirror the `title` tag in React 19 that only accepts a single string */
const DocumentTitle = ({children}: Props) => (
  /**
   * Helmet does not seem to reliably update its contents on prop changes, resulting in stale head tags.
   * Assigning a key ensures that the component is recreated rather than updated, which seems to fix the issue.
   */
  <Helmet key={children}>
    <title>{children}</title>
  </Helmet>
);

export default DocumentTitle;
